/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChartTooltip } from "@octopusdeploy/design-system-components";
import { InsightsGranularity } from "@octopusdeploy/octopus-server-client";
import type { InsightsCadence } from "@octopusdeploy/portal-routes";
import type { ObjectPropertyPath } from "@octopusdeploy/type-utils";
import cn from "classnames";
import { get } from "lodash";
import type { ParsedInsightsAllMetricsInterval } from "~/areas/insights/dataTransformation/getChartReadyInsightsData";
import { getChartAxisDateFormatter } from "../../../dataTransformation/dateHelpers";
import { insightsCadenceLookup } from "../../../insightsCadence";
import styles from "./styles.module.less";
interface MultiSeriesTooltip {
    dataKey: ObjectPropertyPath<ParsedInsightsAllMetricsInterval>;
    cadence: InsightsCadence;
    valueFormatter?: (value: any) => string | number;
    showSeries?: boolean;
}
const defaultValueFormatter = (val: any) => val ?? "No Deployments";
export function InsightsTooltip({ dataKey, valueFormatter = defaultValueFormatter, cadence, showSeries, ...rest }: MultiSeriesTooltip) {
    const { granularity } = insightsCadenceLookup[cadence];
    const dateFormatter = getChartAxisDateFormatter(granularity);
    const labelFormatter = (label?: string | number) => {
        if (!label && label !== 0)
            return "";
        if (granularity === InsightsGranularity.Weekly)
            return `Week starting ${dateFormatter(label)}`;
        return dateFormatter(label);
    };
    return (<ChartTooltip<ParsedInsightsAllMetricsInterval> {...rest}>
            {({ payload, label }) => (<>
                    <span className={cn(styles.textColor, styles.label)}>{labelFormatter(label)}</span>
                    <ul className={cn(styles.textColor, styles.list)}>
                        {payload.map((p, idx) => (<li key={`series-${idx}`} className={styles.listItem}>
                                {showSeries && <div className={styles.colorIndicator} style={{ backgroundColor: p.color }}/>}
                                {showSeries && <span>{p.name}: </span>}
                                {valueFormatter(get(p.payload, dataKey))}
                            </li>))}
                    </ul>
                </>)}
        </ChartTooltip>);
}
